import { Component, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { FeatureFlagService } from '@galaxy/partner';
import { combineLatest, map, switchMap } from 'rxjs';
import { SmsContext } from '../interface';
import { SmsContextToken } from '../token';

@Component({
  selector: 'sms-feature-flag-gate',
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    @switch (allEnabled()) {
      @case (true) {
        <ng-content select="[enabled]"></ng-content>
      }
      @case (false) {
        <ng-content select="[disabled]"></ng-content>
      }
    }
  `,
})
export class FeatureFlagGateComponent {
  readonly featureFlags = input.required<string[]>();

  private readonly smsContext = inject<SmsContext>(SmsContextToken);
  private readonly featureFlagService = inject(FeatureFlagService);

  private readonly featureFlags$ = toObservable(this.featureFlags);

  protected readonly allEnabled = toSignal(
    combineLatest([this.smsContext.featureFlagInfo$, this.featureFlags$]).pipe(
      switchMap(([{ partnerId, marketId }, flags]) =>
        this.featureFlagService
          .batchGetStatus(partnerId, marketId ?? '', flags)
          .pipe(map((status) => flags.every((flag) => status[flag] === true))),
      ),
    ),
    { initialValue: false },
  );
}
